import { useSyncExternalStore } from 'react';

/** O que o cliente está fazendo na conversa (aviso `contact.typing`). */
export type TypingState = 'composing' | 'recording';

/** Sem novo aviso, o "digitando" some sozinho (o WhatsApp nem sempre avisa que parou). */
const EXPIRES_MS = 15_000;

const state = new Map<string, { state: TypingState; timer: ReturnType<typeof setTimeout> }>();
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

/** Guarda o estado da conversa; `null` (parou ou chegou a mensagem) apaga. Fica só em memória. */
export function setTyping(conversationId: string, next: TypingState | null): void {
  const current = state.get(conversationId);
  if (current) clearTimeout(current.timer);
  if (!next) {
    if (current && state.delete(conversationId)) emit();
    return;
  }
  const timer = setTimeout(() => setTyping(conversationId, null), EXPIRES_MS);
  state.set(conversationId, { state: next, timer });
  if (current?.state !== next) emit();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Estado do cliente na conversa, ou null. */
export function useTyping(conversationId: string | null | undefined): TypingState | null {
  return useSyncExternalStore(subscribe, () => (conversationId ? (state.get(conversationId)?.state ?? null) : null));
}

export const typingLabel = (s: TypingState) => (s === 'recording' ? 'gravando áudio…' : 'digitando…');
